import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

export function getClientes(body) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/clientes", body, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                // localStorage.setItem("clientes", JSON.stringify(resposta.data.Rows))
                resposta.data.Rows.forEach(element => {
                    element.chamados = 1
                });
                resolve(resposta.data.Rows)
            }
        })
    })
}
export function getDetalhesClientes(body) {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/detalhescliente", body, config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resposta.data.Rows.forEach(element => {
                    element.chamados = 1
                });
                resolve(resposta.data.Rows)
            }
        })
    })
}

export function changeDesbloqueiocliente(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/desbloqueiocliente", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function changeDestinoChamados(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/setclintedestinochamado", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function changeAplicativoChamados(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/setclinteaplicativochamado", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function setEmailJira(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/setemailjira", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function getEmailJira(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/getemailjira", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function changeBloqueiocliente(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/bloqueiocliente", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function getClientesGrupos(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/listaclientesgrupos", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function getDetalhesLicensa(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/listadetalheslicensa", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function listaDependentes(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/listadependentes", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function cadastraDependente(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/cadastradependente", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function deletaDependente(body) {
    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/deletadependente", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}

export function autorizacaoExtraordinaria(body) {
    console.log(body)
    var config = {
        headers: {
            token: localStorage.getItem('token'),
            "Content-Type": 'application/json'
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(API_URL + "/restfull/emsweb/autorizacaoextraordinaria", body, config).then(resposta => {
            resolve(resposta.data)
        })
    })
}
